import ExternalUsersContext from "@/contexts/data/ExternalUsersContext";
import useExternalUsers from "@/hooks/data/useExternalUsers";
import { FC, PropsWithChildren } from "react";

interface IExternalUsersProviderProps extends PropsWithChildren {

}

export const ExternalUsersProvider: FC<IExternalUsersProviderProps> = ({
    children
}) => {
    const context = useExternalUsers();
    return (
        <ExternalUsersContext.Provider value={context}>
            {children}
        </ExternalUsersContext.Provider>
    )
};

export default ExternalUsersProvider;